import React, { forwardRef } from 'react'
import { BoxProps } from './Box.types'
import { StyledBox } from './Box.styles'

const Box = forwardRef<HTMLElement, BoxProps>(
  (
    {
      as = 'div',
      children,
      // Layout props
      display,
      flexDirection,
      flexWrap,
      alignItems,
      justifyContent,
      gap,
      flex,
      flexShrink,
      // Spacing props
      margin,
      marginTop,
      marginRight,
      marginBottom,
      marginLeft,
      marginX,
      marginY,
      m,
      mt,
      mr,
      mb,
      ml,
      mx,
      my,
      padding,
      paddingTop,
      paddingRight,
      paddingBottom,
      paddingLeft,
      paddingX,
      paddingY,
      p,
      pt,
      pr,
      pb,
      pl,
      px,
      py,
      // Sizing props
      width,
      height,
      minWidth,
      minHeight,
      maxWidth,
      maxHeight,
      // Position props
      position,
      top,
      right,
      bottom,
      left,
      zIndex,
      // Background props
      backgroundColor,
      backgroundImage,
      backgroundSize,
      backgroundPosition,
      backgroundRepeat,
      // Border props
      border,
      borderRadius,
      borderColor,
      borderWidth,
      borderStyle,
      // Typography props
      textAlign,
      color,
      // Other props
      overflow,
      cursor,
      opacity,
      boxShadow,
      transform,
      ...restProps
    },
    ref
  ) => {
    const styledProps = {
      $display: display,
      $flexDirection: flexDirection,
      $flexWrap: flexWrap,
      $alignItems: alignItems,
      $justifyContent: justifyContent,
      $gap: gap,
      $flex: flex,
      $flexShrink: flexShrink,
      $margin: m || margin,
      $marginTop: mt || marginTop,
      $marginRight: mr || marginRight,
      $marginBottom: mb || marginBottom,
      $marginLeft: ml || marginLeft,
      $marginX: mx || marginX,
      $marginY: my || marginY,
      $padding: p || padding,
      $paddingTop: pt || paddingTop,
      $paddingRight: pr || paddingRight,
      $paddingBottom: pb || paddingBottom,
      $paddingLeft: pl || paddingLeft,
      $paddingX: px || paddingX,
      $paddingY: py || paddingY,
      $width: width,
      $height: height,
      $minWidth: minWidth,
      $minHeight: minHeight,
      $maxWidth: maxWidth,
      $maxHeight: maxHeight,
      $position: position,
      $top: top,
      $right: right,
      $bottom: bottom,
      $left: left,
      $zIndex: zIndex,
      $backgroundColor: backgroundColor,
      $backgroundImage: backgroundImage,
      $backgroundSize: backgroundSize,
      $backgroundPosition: backgroundPosition,
      $backgroundRepeat: backgroundRepeat,
      $border: border,
      $borderRadius: borderRadius,
      $borderColor: borderColor,
      $borderWidth: borderWidth,
      $borderStyle: borderStyle,
      $textAlign: textAlign,
      $color: color,
      $overflow: overflow,
      $cursor: cursor,
      $opacity: opacity,
      $boxShadow: boxShadow,
      $transform: transform,
    }

    return (
      <StyledBox as={as} ref={ref} {...styledProps} {...restProps}>
        {children}
      </StyledBox>
    )
  }
)

Box.displayName = 'Box'

export default Box
